import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointLg} from '@/tokens/variables.js'

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const filterToggleStyles = css`

    :host {
        --link__border--focus: var(--_link-border-focus, var(--sbkLinkBorderOnLightFocus));
        --link__color: var(--_link-color, var(--sbkLinkFgColorOnLightEnabled));
        --link__color--hover: var(--_link-color-hover, var(--sbkLinkFgColorOnLightHover));
        --link__color--active: var(--_link-color-active, var(--sbkLinkFgColorOnLightActive)); 
        box-sizing: border-box;
        display: block;
    }

  button {
      display: flex;
      background-color: unset;
      gap: var(--sbkLinkSpacing4xs);
      align-items: center;
      outline: 2px solid transparent;
      outline-offset: var(--sbkLinkBorderGapFocus);
      border-radius: var(--sbkLinkBorderRadiusFocus);
      border: none;
      cursor: pointer;
      text-decoration: none;
      color: var(--link__color);
      fill: currentColor;
      padding: 0;
      font: inherit;
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover {
        color : var(--link__color--hover);
    }
  }

  button:active {
    color : var(--link__color--active);
  }

  button:focus {
    outline: none;
  }

  button:focus-visible {
    outline: var(--link__border--focus);
  }

  #accordion-panel {
    padding-top: var(--sbkAccordionXs);
  }

  #accordion-header {
    font: var(--sbkAccordionTypographySmallScrTitle);
  }

  dd {
    margin-inline-start: 0 ;
  }
    
    .accordion-container {
        margin: 0;
    }

  sbk-icon {
    transition: transform 0.3s ease;
  }

  button[aria-expanded="true"] sbk-icon {
    transform: rotate(-180deg);
  }

  @media (min-width: ${breakpointLg}) {
    #accordion-header {
      font: var(--sbkAccordionTypographyLargeScrTitle);
    }
  }
`;